
export {}
declare global {
 interface Window {
   YT: any,
   player: any,
 }
}

addEventListener("load", ()=>{
 loadVideo()
})

const iframeBoxImg = document.querySelector(".section2 .iframeBox-img")
const iframeBox = document.querySelector(".section2 .iframeBox")

function loadVideo() {
 const tag = document.createElement("script");
 tag.src = "https://www.youtube.com/iframe_api";

 const firstScriptTag = document.getElementsByTagName("script")[0];
 firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

 tag.onload = setupPlayer;
}

function getVideoId(videoUrl: string, callback: any) {
 if (videoUrl) {
   const match = videoUrl.match(
     /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
   );
   const id = match && match[7].length == 11 ? match[7] : false;
   id && callback(id);
 }
}

function setupPlayer() {
 const videoUrl = document.querySelector(".section2")?.getAttribute("video-url") as string
 videoUrl && getVideoId(videoUrl, (id: string) => {
   window.YT.ready(function () {
     window.player = new window.YT.Player("play", {
       height: "390",
       width: "640",
       controls: 2,
       videoId: id,
       rel: 0,
       showinfo: 0,
       autohide: 1,
       events: {
         onReady: onPlayerReady,
         onStateChange: onPlayerStateChange
       }
     })
   });
 })
}

function onPlayerReady(event: any) {
//  event.target.mute();
//  event.target.setVolume(0)
//  event.target.playVideo()

//  setTimeout(() => {
//   event.target.unMute();
//   event.target.setVolume(50)
// }, 1000);

 iframeBox?.addEventListener("click", () => {
  iframeBoxImg?.classList.add("hide")
   event.target.playVideo()
   event.target.unMute();
   event.target.setVolume(50);
 })
}

function onPlayerStateChange(event: any) {
 if (event.target.getPlayerState() === 2) {
   setTimeout(() => {
     event.target.getPlayerState() === 2 && iframeBoxImg?.classList.remove("hide")
   }, 500);
 }

 event.target.getPlayerState() === 3 && iframeBoxImg?.classList.add("hide")

 event.target.getPlayerState() === 1 && iframeBoxImg?.classList.add("hide")

 if (event.target.getPlayerState() === 0) {
   event.target.stopVideo()
   iframeBoxImg?.classList.remove("hide")
 }
}
